import { TipoAtendimentoUsuario } from '../_enums';

export class TipoServicoAtendimento {
    id: string;
    cnsCartorio: string;
    descricao: string;
    tipoAtendimento: TipoAtendimentoUsuario;
    mensagemFinalAtendimento: string;
}
